import { render, staticRenderFns } from "./DeactivationComment.vue?vue&type=template&id=a13f05a4&scoped=true&"
import script from "./DeactivationComment.vue?vue&type=script&lang=ts&"
export * from "./DeactivationComment.vue?vue&type=script&lang=ts&"
import style0 from "./DeactivationComment.vue?vue&type=style&index=0&id=a13f05a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13f05a4",
  null
  
)

export default component.exports